import { useState, useEffect } from 'react';
import { getMutationCount } from '../utils/offlineDB';

/**
 * Retourne le nombre de mutations en attente de synchronisation.
 * Se met à jour automatiquement via les événements custom :
 *   - 'gf:mutation-queued'  → une mutation a été ajoutée
 *   - 'gf:mutation-synced'  → une mutation a été synchronisée ou mise en erreur
 */
export function useMutationCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    // Chargement initial
    getMutationCount().then(setCount).catch(() => setCount(0));

    // Mise à jour réactive
    const refresh = () => getMutationCount().then(setCount).catch(() => {});
    window.addEventListener('gf:mutation-queued', refresh);
    window.addEventListener('gf:mutation-synced', refresh);

    return () => {
      window.removeEventListener('gf:mutation-queued', refresh);
      window.removeEventListener('gf:mutation-synced', refresh);
    };
  }, []);

  return count;
}
